import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  getAssessmentAttemptByUserId,
  getInsightfulContent,
  sendToFriendReportOnEmail,
} from "../dashboard/actions";
import { createContentMap, getContentLatestVersion } from "../signup/actions";
import CareerPrecontent from "./component";
import { GetUserById } from "../settings/actions";

const mapStateToProps = ({ funnelStep }) => ({
  funnelStep,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getInsightfulContentConnect: getInsightfulContent,
      getContentLatestVersionConnect: getContentLatestVersion,
      createContentMapConnect: createContentMap,
      getAssessmentAttemptByUserIdConnect: getAssessmentAttemptByUserId,
      getUserByIdConnect: GetUserById,
      sendToFriendReportOnEmailConnect: sendToFriendReportOnEmail,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CareerPrecontent);
